/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Plan_Ends_OnInputs */

const en_plan_ends_on = /** @type {(inputs: Plan_Ends_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ends ${i?.date}`)
};

const es_plan_ends_on = /** @type {(inputs: Plan_Ends_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Termina el ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Ends {date}" |
*
* @param {Plan_Ends_OnInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_ends_on = /** @type {((inputs: Plan_Ends_OnInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Ends_OnInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_ends_on(inputs)
	return en_plan_ends_on(inputs)
});